import React, { createContext, useContext, useState } from 'react';

interface NotificationsContextType {
  unreadCommandes: number;
  setUnreadCommandes: (count: number) => void;
  unreadOperations: number;
  setUnreadOperations: (count: number) => void;
}

const NotificationsContext = createContext<NotificationsContextType | undefined>(undefined);

export const NotificationsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [unreadCommandes, setUnreadCommandes] = useState(0);
  const [unreadOperations, setUnreadOperations] = useState(0);

  return (
    <NotificationsContext.Provider value={{
      unreadCommandes,
      setUnreadCommandes,
      unreadOperations,
      setUnreadOperations
    }}>
      {children}
    </NotificationsContext.Provider>
  );
};

export const useNotifications = () => {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error('useNotifications must be used within a NotificationsProvider');
  }
  return context;
};